export default __webpack_public_path__ + "static/media/three-vignette.cda91f09.vert";